import { HowToFixBtn } from './fragments'
import SnackbarWrapper from './wrapper'

const RebootingSnackbar = () => {
  return (
    <SnackbarWrapper status="failed">
      <h5>Error...</h5>
      <h5 className="light">Bag is rebooting</h5>
      <HowToFixBtn />
    </SnackbarWrapper>
  )
}

export default RebootingSnackbar
